export const LANGUAGES = [
  { code: 'en', label: 'English', flag: '🇬🇧', dir: 'ltr' },
  { code: 'hi', label: 'हिन्दी', flag: '🇮🇳', dir: 'ltr' },
  { code: 'fr', label: 'Français', flag: '🇫🇷', dir: 'ltr' },
  { code: 'ru', label: 'Русский', flag: '🇷🇺', dir: 'ltr' },
  { code: 'bn', label: 'বাংলা', flag: '🇧🇩', dir: 'ltr' },
  { code: 'ta', label: 'தமிழ்', flag: '🇮🇳', dir: 'ltr' },
  { code: 'zh', label: '中文', flag: '🇨🇳', dir: 'ltr' },
  { code: 'es', label: 'Español', flag: '🇪🇸', dir: 'ltr' },
  { code: 'ar', label: 'العربية', flag: '🇸🇦', dir: 'rtl' },
  { code: 'pt', label: 'Português', flag: '🇵🇹', dir: 'ltr' },
];

const en = {
  'brand.tagline': 'GLOBAL TRADING EXCHANGE',
  'nav.markets': 'Markets', 'nav.sibot': 'S.I. Bot', 'nav.howItWorks': 'How It Works',
  'nav.faq': 'FAQ', 'nav.support': 'Support', 'nav.login': 'Log In', 'nav.register': 'Register',
  'nav.getStarted': 'Get Started', 'nav.dashboard': 'Dashboard', 'nav.exploreMarkets': 'Explore Markets',
  'nav.logout': 'Log Out', 'nav.admin': 'Admin',
  'hero.headline': 'INTELLIGENCE MEETS GLOBAL TRADING.',
  'hero.sub': 'Discover a unified cryptocurrency trading platform combining market intelligence, automated workflows, and transparent account management.',
  'hero.discoverBot': 'Discover S.I. Bot', 'hero.viewData': 'View Market Data',
  'section.liveMarkets': 'Live Market Overview', 'section.sibot': 'The S.I. Bot',
  'section.howItWorks': 'How The Platform Works', 'section.security': 'Security & Blockchain Infrastructure',
  'section.features': 'Platform Features', 'section.risk': 'Risk Disclosure', 'section.faq': 'Frequently Asked Questions',
  'steps.1': 'Register and secure your account', 'steps.2': 'Complete applicable identity verification',
  'steps.3': 'Deposit supported USDT BEP20', 'steps.4': 'View verified funds and trading allocation',
  'steps.5': 'Monitor trading, settlements, and eligible withdrawals',
  'common.price': 'Price', 'common.change24h': '24h', 'common.volume': 'Volume', 'common.marketCap': 'Market Cap',
  'common.loading': 'Loading…', 'common.save': 'Save', 'common.cancel': 'Cancel', 'common.submit': 'Submit',
  'common.copy': 'Copy', 'common.copied': 'Copied', 'common.amount': 'Amount', 'common.status': 'Status',
  'common.date': 'Date', 'common.actions': 'Actions', 'common.email': 'Email', 'common.password': 'Password',
  'auth.loginTitle': 'Welcome back', 'auth.registerTitle': 'Create your account',
  'auth.fullName': 'Full name', 'auth.country': 'Country', 'auth.confirmPassword': 'Confirm password',
  'auth.acceptTerms': 'I accept the Terms of Service and Privacy Policy',
  'auth.noAccount': "Don't have an account?", 'auth.hasAccount': 'Already have an account?',
  'auth.forgot': 'Forgot password?',
  'dash.overview': 'Dashboard', 'dash.trading': 'Trading', 'dash.orders': 'Orders', 'dash.wallet': 'Wallet',
  'dash.deposits': 'Deposits', 'dash.withdrawals': 'Withdrawals', 'dash.settlements': 'Settlements',
  'dash.history': 'History', 'dash.notifications': 'Notifications', 'dash.settings': 'Settings',
  'dash.security': 'Security', 'dash.totalDeposits': 'Total Verified Deposits',
  'dash.availableBalance': 'Available Balance', 'dash.allocation': 'Trading Allocation',
  'dash.realizedPnl': 'Realized P&L', 'dash.withdrawable': 'Withdrawable', 'dash.netEquity': 'Net Equity',
};

const translate = (base) => ({ ...en, ...base });

export const translations = {
  en,
  hi: translate({
    'nav.markets': 'बाज़ार', 'nav.sibot': 'एस.आई. बॉट', 'nav.howItWorks': 'यह कैसे काम करता है',
    'nav.faq': 'सामान्य प्रश्न', 'nav.support': 'सहायता', 'nav.login': 'लॉग इन', 'nav.register': 'रजिस्टर',
    'nav.getStarted': 'शुरू करें', 'nav.dashboard': 'डैशबोर्ड', 'nav.exploreMarkets': 'बाज़ार देखें',
    'hero.headline': 'बुद्धिमत्ता मिलती है वैश्विक ट्रेडिंग से।',
    'hero.sub': 'एक एकीकृत क्रिप्टोकरेंसी ट्रेडिंग प्लेटफ़ॉर्म खोजें जो बाज़ार बुद्धिमत्ता, स्वचालित वर्कफ़्लो और पारदर्शी खाता प्रबंधन को जोड़ता है।',
    'hero.discoverBot': 'एस.आई. बॉट देखें', 'hero.viewData': 'बाज़ार डेटा देखें',
    'dash.overview': 'डैशबोर्ड', 'dash.deposits': 'जमा', 'dash.withdrawals': 'निकासी',
  }),
  fr: translate({
    'nav.markets': 'Marchés', 'nav.howItWorks': 'Comment ça marche', 'nav.support': 'Assistance',
    'nav.login': 'Connexion', 'nav.register': "S'inscrire", 'nav.getStarted': 'Commencer',
    'nav.dashboard': 'Tableau de bord', 'nav.exploreMarkets': 'Explorer les marchés',
    'hero.headline': "L'INTELLIGENCE RENCONTRE LE TRADING MONDIAL.",
    'hero.sub': "Découvrez une plateforme unifiée de trading de cryptomonnaies combinant intelligence de marché, flux automatisés et gestion de compte transparente.",
    'hero.discoverBot': 'Découvrir le S.I. Bot', 'hero.viewData': 'Voir les données',
    'dash.overview': 'Tableau de bord', 'dash.deposits': 'Dépôts', 'dash.withdrawals': 'Retraits',
  }),
  ru: translate({
    'nav.markets': 'Рынки', 'nav.howItWorks': 'Как это работает', 'nav.support': 'Поддержка',
    'nav.login': 'Вход', 'nav.register': 'Регистрация', 'nav.getStarted': 'Начать',
    'nav.dashboard': 'Панель', 'nav.exploreMarkets': 'Рынки',
    'hero.headline': 'ИНТЕЛЛЕКТ ВСТРЕЧАЕТ ГЛОБАЛЬНУЮ ТОРГОВЛЮ.',
    'hero.sub': 'Откройте единую платформу для торговли криптовалютой, объединяющую рыночную аналитику, автоматизацию и прозрачное управление счётом.',
    'hero.discoverBot': 'Узнать о S.I. Bot', 'hero.viewData': 'Данные рынка',
    'dash.overview': 'Панель', 'dash.deposits': 'Депозиты', 'dash.withdrawals': 'Вывод',
  }),
  bn: translate({
    'nav.markets': 'বাজার', 'nav.howItWorks': 'কিভাবে কাজ করে', 'nav.support': 'সহায়তা',
    'nav.login': 'লগ ইন', 'nav.register': 'নিবন্ধন', 'nav.getStarted': 'শুরু করুন',
    'nav.dashboard': 'ড্যাশবোর্ড', 'nav.exploreMarkets': 'বাজার দেখুন',
    'hero.headline': 'বুদ্ধিমত্তা মিলিত হয় বৈশ্বিক ট্রেডিংয়ের সাথে।',
    'hero.sub': 'একটি সমন্বিত ক্রিপ্টোকারেন্সি ট্রেডিং প্ল্যাটফর্ম আবিষ্কার করুন যা বাজার বুদ্ধিমত্তা, স্বয়ংক্রিয় ওয়ার্কফ্লো এবং স্বচ্ছ অ্যাকাউন্ট ব্যবস্থাপনা একত্রিত করে।',
    'hero.discoverBot': 'S.I. Bot দেখুন', 'hero.viewData': 'বাজার ডেটা',
    'dash.overview': 'ড্যাশবোর্ড', 'dash.deposits': 'জমা', 'dash.withdrawals': 'উত্তোলন',
  }),
  ta: translate({
    'nav.markets': 'சந்தைகள்', 'nav.howItWorks': 'எப்படி வேலை செய்கிறது', 'nav.support': 'ஆதரவு',
    'nav.login': 'உள்நுழை', 'nav.register': 'பதிவு', 'nav.getStarted': 'தொடங்கு',
    'nav.dashboard': 'டாஷ்போர்டு', 'nav.exploreMarkets': 'சந்தைகளை பார்',
    'hero.headline': 'நுண்ணறிவு உலகளாவிய வர்த்தகத்தை சந்திக்கிறது.',
    'hero.sub': 'சந்தை நுண்ணறிவு, தானியங்கி பணிப்பாய்வுகள் மற்றும் வெளிப்படையான கணக்கு மேலாண்மையை இணைக்கும் ஒருங்கிணைந்த கிரிப்டோ வர்த்தக தளத்தைக் கண்டறியுங்கள்.',
    'hero.discoverBot': 'S.I. Bot ஐ அறிக', 'hero.viewData': 'சந்தை தரவு',
    'dash.overview': 'டாஷ்போர்டு', 'dash.deposits': 'வைப்புகள்', 'dash.withdrawals': 'திரும்பப் பெறுதல்',
  }),
  zh: translate({
    'nav.markets': '市场', 'nav.howItWorks': '运作方式', 'nav.support': '支持',
    'nav.login': '登录', 'nav.register': '注册', 'nav.getStarted': '开始使用',
    'nav.dashboard': '仪表板', 'nav.exploreMarkets': '浏览市场',
    'hero.headline': '智能遇见全球交易。',
    'hero.sub': '探索一个统一的加密货币交易平台，融合市场情报、自动化工作流程和透明的账户管理。',
    'hero.discoverBot': '了解 S.I. Bot', 'hero.viewData': '查看市场数据',
    'dash.overview': '仪表板', 'dash.deposits': '充值', 'dash.withdrawals': '提现',
  }),
  es: translate({
    'nav.markets': 'Mercados', 'nav.howItWorks': 'Cómo funciona', 'nav.support': 'Soporte',
    'nav.login': 'Iniciar sesión', 'nav.register': 'Registrarse', 'nav.getStarted': 'Empezar',
    'nav.dashboard': 'Panel', 'nav.exploreMarkets': 'Explorar mercados',
    'hero.headline': 'LA INTELIGENCIA SE ENCUENTRA CON EL TRADING GLOBAL.',
    'hero.sub': 'Descubre una plataforma unificada de trading de criptomonedas que combina inteligencia de mercado, flujos automatizados y gestión transparente de cuentas.',
    'hero.discoverBot': 'Descubrir S.I. Bot', 'hero.viewData': 'Ver datos del mercado',
    'dash.overview': 'Panel', 'dash.deposits': 'Depósitos', 'dash.withdrawals': 'Retiros',
  }),
  ar: translate({
    'nav.markets': 'الأسواق', 'nav.howItWorks': 'كيف يعمل', 'nav.support': 'الدعم',
    'nav.login': 'تسجيل الدخول', 'nav.register': 'التسجيل', 'nav.getStarted': 'ابدأ الآن',
    'nav.dashboard': 'لوحة التحكم', 'nav.exploreMarkets': 'استكشاف الأسواق',
    'hero.headline': 'الذكاء يلتقي بالتداول العالمي.',
    'hero.sub': 'اكتشف منصة موحدة لتداول العملات المشفرة تجمع بين ذكاء السوق وسير العمل الآلي وإدارة الحساب الشفافة.',
    'hero.discoverBot': 'اكتشف S.I. Bot', 'hero.viewData': 'عرض بيانات السوق',
    'dash.overview': 'لوحة التحكم', 'dash.deposits': 'الإيداعات', 'dash.withdrawals': 'السحوبات',
  }),
  pt: translate({
    'nav.markets': 'Mercados', 'nav.howItWorks': 'Como funciona', 'nav.support': 'Suporte',
    'nav.login': 'Entrar', 'nav.register': 'Registar', 'nav.getStarted': 'Começar',
    'nav.dashboard': 'Painel', 'nav.exploreMarkets': 'Explorar mercados',
    'hero.headline': 'A INTELIGÊNCIA ENCONTRA O TRADING GLOBAL.',
    'hero.sub': 'Descubra uma plataforma unificada de trading de criptomoedas que combina inteligência de mercado, fluxos automatizados e gestão de conta transparente.',
    'hero.discoverBot': 'Descobrir o S.I. Bot', 'hero.viewData': 'Ver dados do mercado',
    'dash.overview': 'Painel', 'dash.deposits': 'Depósitos', 'dash.withdrawals': 'Levantamentos',
  }),
};
